import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  // 供应商管理列表数据 商户端
  supplierList: {
    records: [],
    total: 0
  },
  supplierListPanel: {},
  supplierMark: 0,
  errorMsg: null,
  supplierPrint: {},
  costMask: 0,
  suppliersetList: [],
  // saas端
  supplierListSaas: {
    records: [],
    total: 0
  },
  warehouseList: [],
  ycDispatchPlatformPointList: [],
  IMPORTASKList: {},
  suppliersetEidt: {},
  goodInfo: {
    code: null
  },
  xlsUrl: {}
}

const actions = {
  // 供应商管理列表数据
  [types.GETSUPPLIERLISTMANAGE] (context, params) {
    http.fetch('/api/supplier/getSupplierListManage', params).then(data => {
      context.commit(types.GETSUPPLIERLISTMANAGE, data)
    })
  },
  // 移除
  [types.REMOVESUPPLIER] (context, params) {
    http.fetch('/api/supplier/removeSupplier', params).then(data => {
      context.commit(types.REMOVESUPPLIER, data)
    })
  },
  // 移除验证
  [types.CHECKREMOVESUPPLIER] (context, params) {
    http.fetch('/api/supplier/checkRemoveSupplier', params, null, true).then(data => {
      context.commit(types.CHECKREMOVESUPPLIER, data)
    })
  },
  // 获取未引用的供应商
  [types.GETSUPPLIERLISTPANEL] (context, params) {
    http.fetch('/api/supplier/getSupplierListPanel', params).then(data => {
      context.commit(types.GETSUPPLIERLISTPANEL, data)
    })
  },
  // 编辑回显
  [types.GETSUPPLIER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplier/getSupplier', params).then(data => {
        context.commit(types.GETSUPPLIER, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存 SAVESUPPLIER
  [types.SAVESUPPLIER] (context, params) {
    http.fetch('/api/supplier/saveSupplier', params).then(data => {
      context.commit(types.SAVESUPPLIER, data)
    })
  },
  // 查询打印数据
  [types.GETSUPPLIERPRINT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplier/getSupplierPrint', params).then(data => {
        context.commit(types.GETSUPPLIER, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存打印数据
  [types.SAVESUPPLIERPRINT] (context, params) {
    http.fetch('/api/supplier/saveSupplierPrint', params).then(data => {
      context.commit(types.SAVESUPPLIERPRINT, data)
    })
  },
  // 查询供应商列表 SAAS
  [types.GETALLSUPPLIERLISTSAAS] (context, params) {
    http.fetch('/api/supplier/getAllSupplierListSaaS', params).then(data => {
      context.commit(types.GETALLSUPPLIERLISTSAAS, data)
    })
  },
  // 根据仓库获取配送仓点
  [types.GETYCDISPATCHPLATFORMPOINT] (context, params) {
    http.fetch('/api/ycDispatchPlatformPoint/list', params).then(data => {
      context.commit(types.GETYCDISPATCHPLATFORMPOINT, data)
    })
  },
  // 查询供应商所入驻仓库 SAAS
  [types.GETSUPPLIERWAREHOUSELISTSAAS] (context, params) {
    http.fetch('/api/supplier/getSupplierWarehouseListSaaS', params).then(data => {
      context.commit(types.GETSUPPLIERWAREHOUSELISTSAAS, data)
    })
  },
  // 判断供应商是否可删除 SAAS
  [types.CHECKDELETESUPPLIERSAAS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplier/checkDeleteSupplierSaaS', params).then(data => {
        context.commit(types.GETSUPPLIER, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除供应商 SAAS
  [types.DELETESUPPLIERSAAS] (context, params) {
    http.fetch('/api/supplier/deleteSupplierSaaS', params).then(data => {
      context.commit(types.DELETESUPPLIERSAAS, data)
    })
  },
  // 获取供应商详细信息 SAAS
  [types.GETSUPPLIERSAAS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplier/getSupplierSaaS', params).then(data => {
        context.commit(types.GETSUPPLIER, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 确认联系人是否可删除 SAAS
  [types.CHECKDELETESUPPLIERCONTACTPERSONSAAS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplier/checkDeleteSupplierContactPersonSaaS', params).then(data => {
        context.commit(types.GETSUPPLIER, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存供应商 SAAS
  [types.SAVESUPPLIERSAAS] (context, params) {
    http.fetch('/api/supplier/saveSupplierSaaS', params).then(data => {
      context.commit(types.SAVESUPPLIERSAAS, data)
    })
  },
  // 导入
  [types.IMPORTSUPPLIER] (context, params) {
    http.fetch('/api/supplier/importSupplier', params).then(data => {
      context.commit(types.IMPORTSUPPLIER, data)
    })
  },
  // ======================以上是新接口，以下是旧数据 20210825=====================
  // // 禁用
  // [types.UPDATESTATUS] (context, params) {
  //   http.fetch('/api/supplier/updateStatus', params).then(data => {
  //     context.commit(types.UPDATESTATUS, data)
  //   })
  // },
  // // 新增
  // [types.SUPPLIERADD] (context, params) {
  //   http.fetch('/api/supplier/add', params).then(data => {
  //     context.commit(types.SUPPLIERADD, data)
  //   })
  // },
  // // 修改
  // [types.SUPPLIERUPDATA] (context, params) {
  //   http.fetch('/api/supplier/update', params).then(data => {
  //     context.commit(types.SUPPLIERUPDATA, data)
  //   })
  // },

  // // 供应商管理-修改密码
  // [types.SUPPLIERUPDATEPWD] (context, params) {
  //   http.fetch('/api/supplier/updatePwd', params).then(data => {
  //     context.commit(types.SUPPLIERUPDATEPWD, data)
  //   })
  // },
  // 费用配置-查询
  [types.GETSUPPLIERCOST] (context, params) {
    http.fetch('/api/supplier/getSupplierCost', params).then(data => {
      context.commit(types.GETSUPPLIERCOST, data)
    })
  },
  // 新增供应商费用配置
  [types.SUPPLIERADDCOST] (context, params) {
    http.fetch('/api/supplier/addCost', params, 'application/json').then(data => {
      context.commit(types.SUPPLIERADDCOST, data)
    })
  },
  // 编辑供应商费用配置回显
  [types.GETCOSTBYID] (context, params) {
    http.fetch('/api/supplier/getCostById', params).then(data => {
      context.commit(types.GETCOSTBYID, data)
    })
  },
  // 更新供应商费用配置
  [types.SUPPLIERUPDATECOST] (context, params) {
    http.fetch('/api/supplier/updateCost', params, 'application/json').then(data => {
      context.commit(types.SUPPLIERUPDATECOST, data)
    })
  },
  // 删除供应商费用配置
  [types.SUPPLIERDELETE] (context, params) {
    http.fetch('/api/supplier/delCost', params).then(data => {
      context.commit(types.SUPPLIERDELETE, data)
    })
  }
}

const mutations = {
  // 供应商管理列表数据
  [types.GETSUPPLIERLISTMANAGE] (state, data) {
    state.supplierList = data.obj
  },
  // 移除
  [types.REMOVESUPPLIER] (state, data) {
    if (data.code === 200) {
      state.supplierMark = 1
      vue.$message({
        message: '移除成功！',
        type: 'success'
      })
    } else {
      vue.$message({
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 移除验证
  [types.CHECKREMOVESUPPLIER] (state, data) {
    /**
     *  判断请处理后再移除 -》 code：501 success：false
     *  判断供应商商品库存＞0 -》code：501 success：true
     *  通过-》 code：200 success：true
     */
    if (data.code === 200) {
      if (data.success) {
        state.supplierMark = 6
      } else {
        state.supplierMark = 5
        state.errorMsg = data.message
      }
    } else if (data.code === 500) {
      state.supplierMark = 4
      state.errorMsg = data.message
    }
  },
  // 获取未引用的供应商
  [types.GETSUPPLIERLISTPANEL] (state, data) {
    state.supplierListPanel = data
  },
  // 编辑回显
  [types.GETSUPPLIER] (state, data) {
    state.goodInfo = data.obj
  },
  // 保存
  [types.SAVESUPPLIER] (state, data) {
    if (data.code === 200) {
      state.supplierMark = 1
      vue.$message({
        message: '保存成功！',
        type: 'success'
      })
    }
  },
  // 查询打印配置
  [types.GETSUPPLIERPRINT] (state, data) {
    state.supplierPrint = data
  },
  // 保存打印配置
  [types.SAVESUPPLIERPRINT] (state, data) {
    if (data.code === 200) {
      state.supplierMark = 1
      vue.$message({
        message: '保存成功！',
        type: 'success'
      })
    }
  },
  // 供应商管理列表数据 SAAS
  [types.GETALLSUPPLIERLISTSAAS] (state, data) {
    state.supplierListSaas = {
      rows: data.obj.records,
      total: data.obj.total
    }
    console.log(data, '供应商管理列表数据')
  },
  // 根据仓库获取配送仓点
  [types.GETYCDISPATCHPLATFORMPOINT] (state, data) {
    state.ycDispatchPlatformPointList = data.obj
    console.log(data, '根据仓库获取配送仓点')
  },
  // 查询供应商所入驻仓库 SAAS GETSUPPLIERWAREHOUSELISTSAAS warehouseList
  [types.GETSUPPLIERWAREHOUSELISTSAAS] (state, data) {
    state.warehouseList = data.obj
    console.log(data, '供应商所入驻仓库')
  },
  // 删除供应商 DELETESUPPLIERSAAS
  [types.DELETESUPPLIERSAAS] (state, data) {
    if (data.code === 200) {
      state.supplierMark = 1
      vue.$message({
        message: '删除成功！',
        type: 'success'
      })
    }
  },
  // 保存 SAAS SAVESUPPLIERSAAS
  [types.SAVESUPPLIERSAAS] (state, data) {
    if (data.code === 200) {
      state.supplierMark = 1
      vue.$message({
        message: '保存成功！',
        type: 'success'
      })
    }
  },
  // 导入 IMPORTSUPPLIER
  [types.IMPORTSUPPLIER] (state, data) {
    if (data.code !== 200) {
      state.supplierMark = -1
      state.xlsUrl = {
        url: '',
        message: data.message
      }
      return false
    }
    console.log(data.obj)
    if (data.obj) {
      state.xlsUrl = {
        url: data.obj.errExcelUrl
      }
      state.supplierMark = 3
    } else {
      state.xlsUrl = {
        url: '',
        message: '供应商信息导入成功'
      }
      state.supplierMark = 2
      // console.log('导入成功')
    }
  },
  // ======================以上是新接口，以下是旧数据====================

  // // 禁用
  // [types.UPDATESTATUS] (state, data) {
  //   if (data.code === 200) {
  //     state.supplierMark = 1
  //     vue.$message({
  //       showClose: true,
  //       message: data.message,
  //       type: 'success'
  //     })
  //   } else {
  //     vue.$message({
  //       showClose: true,
  //       message: data.message,
  //       type: 'warning'
  //     })
  //   }
  // },
  // // 新增
  // [types.SUPPLIERADD] (state, data) {
  //   // state.supplierData = data.supplier
  //   // state.costList = data.costList
  //   if (data.code === 200) {
  //     state.costMask = 1
  //     vue.$message({
  //       showClose: true,
  //       message: '新增成功',
  //       type: 'success'
  //     })
  //   } else {
  //     vue.$message({
  //       showClose: true,
  //       message: data.message,
  //       type: 'warning'
  //     })
  //   }
  //   console.log(data, '新增')
  // },
  // // 编辑
  // [types.SUPPLIERUPDATA] (state, data) {
  //   if (data.code === 200) {
  //     state.costMask = 1
  //     vue.$message({
  //       showClose: true,
  //       message: '编辑成功',
  //       type: 'success'
  //     })
  //   } else {
  //     vue.$message({
  //       showClose: true,
  //       message: data.message,
  //       type: 'warning'
  //     })
  //   }
  //   console.log(data, '编辑')
  // },

  // // 修改密码
  // [types.SUPPLIERUPDATEPWD] (state, data) {
  //   if (data.code === 200) {
  //     state.supplierMark = 1
  //     vue.$message({
  //       showClose: true,
  //       message: '修改成功',
  //       type: 'success'
  //     })
  //   } else {
  //     vue.$message({
  //       showClose: true,
  //       message: data.message,
  //       type: 'warning'
  //     })
  //   }
  // },
  // 费用配置-查询
  [types.GETSUPPLIERCOST] (state, data) {
    state.suppliersetList = data.obj
    console.log(data, '费用配置-查询')
  },
  // 新增供应商费用配置
  [types.SUPPLIERADDCOST] (state, data) {
    console.log(data, '新增供应商费用配置')
    if (data.code === 200) {
      state.costMask = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 编辑供应商费用配置回显
  [types.GETCOSTBYID] (state, data) {
    if (data.obj.smallestRule) {
      data.obj.smallestRule = JSON.parse(data.obj.smallestRule)
    }
    if (data.obj.ycWarehouseCost) {
      data.obj.ycWarehouseCost.smallestRule = JSON.parse(data.obj.ycWarehouseCost.smallestRule)
      for (const key in data.obj.ycWarehouseCost) {
        data.obj[key] = data.obj.ycWarehouseCost[key]
      }
    }
    state.suppliersetEidt = data.obj
    console.log(data, '编辑供应商费用配置回显')
  },
  // 更新供应商费用配置
  [types.SUPPLIERUPDATECOST] (state, data) {
    if (data.code === 200) {
      state.costMask = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 删除供应商费用配置
  [types.SUPPLIERDELETE] (state, data) {
    if (data.code === 200) {
      state.costMask = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/supplierManage/index.js